import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getImg } from '../utils/getImg';
import defaultArt from '../assets/images/dj_kip_art.png';
import GridCard from './GridCard';
import { useApi } from '../context/ApiProvider';
import { Typography } from '@mui/material';

const CuratorCard = ({ item, showFollowOption = true }) => {
  const [isFollowed, setIsFollowed] = useState(false);
  const api = useApi();

  const {
    art_url_sm,
    art_url_xl,
    default_img_sm,
    default_img_xl,
    name,
    id,
    location,
    city,
    country,
    start_date,
    end_date,
    set_count,
    latest_set_date,
    permalink,
  } = item;

  useEffect(() => {
    const is_followed = item.user_label_stats?.is_followed || false;
    setIsFollowed(is_followed);
  }, [item.user_label_stats]);

  const curatorImg =
    getImg(art_url_xl) ||
    getImg(art_url_sm) ||
    getImg(default_img_xl) ||
    getImg(default_img_sm) ||
    defaultArt;

  // Detect if this is a festival or venue based on permalink or other indicators
  const isFestival =
    permalink &&
    [
      'burning-man',
      'fusion-festival',
      'mayan-warrior',
      'ultra',
      'ultra-music-festival',
      'tomorrowland',
    ].includes(permalink);

  const isVenue =
    permalink && ['club-space', 'hi', 'circoloco'].includes(permalink);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };

  const dateRange =
    start_date && end_date
      ? `${formatDate(start_date)} - ${formatDate(end_date)}`
      : start_date
      ? formatDate(start_date)
      : '';

  const fullLocation = [location, city, country].filter(Boolean).join(', ');

  async function handleFollowClick() {
    try {
      const response = await api.put(`/stats/label/${id}/follow`);
      if (response.ok) {
        setIsFollowed(response.body.is_followed);
      }
    } catch (error) {
      console.error('Error following curator:', error);
    }
  }

  return (
    <GridCard
      title={name}
      art_url={curatorImg}
      tags={[]} // Hide genres
      redirectTo={`/labels/${id}`}
      showFollowOption={showFollowOption}
      isFollowed={isFollowed}
      onFollowClick={handleFollowClick}
    >
      {fullLocation && (
        <Typography variant="body2">📍 {fullLocation}</Typography>
      )}
      {isFestival && dateRange && (
        <Typography variant="body2">📅 {dateRange}</Typography>
      )}
      {set_count > 0 && (
        <Typography variant="body2">Sets: {set_count}</Typography>
      )}
      {latest_set_date && (
        <Typography variant="body2">
          Latest Set: {new Date(latest_set_date).toLocaleDateString()}
        </Typography>
      )}
    </GridCard>
  );
};

CuratorCard.propTypes = {
  item: PropTypes.object.isRequired,
  showFollowOption: PropTypes.bool,
};

export default CuratorCard;
